import { render, staticRenderFns } from "./SinaWeiboEdit.vue?vue&type=template&id=fa135c54&"
import script from "./SinaWeiboEdit.vue?vue&type=script&lang=js&"
export * from "./SinaWeiboEdit.vue?vue&type=script&lang=js&"
import style0 from "./SinaWeiboEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports